/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_Feedback_ListInputs */

const es_tools_nexata_feedback_list = /** @type {(inputs: Tools_Nexata_Feedback_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando feedback...`)
};

const en_tools_nexata_feedback_list = /** @type {(inputs: Tools_Nexata_Feedback_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading feedback...`)
};

/**
* | output |
* | --- |
* | "Loading feedback..." |
*
* @param {Tools_Nexata_Feedback_ListInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_feedback_list = /** @type {((inputs?: Tools_Nexata_Feedback_ListInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_Feedback_ListInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_feedback_list(inputs)
	return en_tools_nexata_feedback_list(inputs)
});
export { tools_nexata_feedback_list as "tools.nexata.feedback_list" }